module.exports = __webpack_public_path__ + "img/_blog1.0ced1737.jpg";